export class DomainResult {
    constructor(query) {
        this._query = query;
        this._domains = new Map();
    }
    get domains() {
        return this._domains;
    }
    getDomain(name) {
        return this.domains.get(name);
    }
    addDomain(name, domain) {
        this.domains.set(name, domain);
    }
}
